import { Euro } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Input } from '@/shared/components/ui';
import { cn } from '@/shared/utils';

const formatCentsForNumberInput = (cents: number): string => {
  const safe = Number.isFinite(cents) ? Math.max(0, Math.trunc(cents)) : 0;
  if (safe === 0) return '';
  return (safe / 100).toFixed(2);
};

const parseNumberInputToCents = (raw: string): number => {
  const normalized = raw.replace(',', '.');
  const value = Number(normalized);
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.round(value * 100));
};

export function CurrencyInput({
  valueCents,
  onValueCentsChange,
  placeholder = '0.00',
  disabled,
  className,
  testId,
}: {
  valueCents: number;
  onValueCentsChange: (cents: number) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  testId?: string;
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [raw, setRaw] = useState(() => formatCentsForNumberInput(valueCents));

  useEffect(() => {
    if (isFocused) return;
    setRaw(formatCentsForNumberInput(valueCents));
  }, [valueCents, isFocused]);

  return (
    <div className={cn('relative', className)}>
      <Euro className="-translate-y-1/2 absolute top-1/2 left-3 size-4 text-muted-foreground" />
      <Input
        data-testid={testId}
        className="bg-background pl-9"
        type="number"
        step="0.01"
        min="0"
        inputMode="decimal"
        placeholder={placeholder}
        value={raw}
        disabled={disabled}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          setIsFocused(false);
          setRaw(formatCentsForNumberInput(valueCents));
        }}
        onChange={(e) => {
          const next = e.target.value;
          setRaw(next);
          onValueCentsChange(parseNumberInputToCents(next));
        }}
      />
    </div>
  );
}
